import React from 'react';

import type { TimelineItem } from '../HistoryDialog.types.ts';

type StepCreationActionProps = {
  item: TimelineItem<'CREATE_STEP'>;
};

export const StepCreationAction: React.FC<StepCreationActionProps> = () => null;
